import stores from "./storesPT.json";
import integration from "./integrationPT.json";

export const storesPT = {
	stores,
	integration,
};
